import { render, staticRenderFns } from "./AddEditBI.vue?vue&type=template&id=10f1f274"
import script from "./AddEditBI.vue?vue&type=script&lang=js"
export * from "./AddEditBI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports